import { useTimeout } from 'react-use';
import DAZZMLogo from './DAZZMLogo.jsx';

export default function Maintenance() {
  const [ready] = useTimeout(120000); // 2 minutes

  if (ready()) {
    window.location.reload();
    return null;
  }

  const language = navigator.language.startsWith('fr') ? 'fr' : 'en';

  return (
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: '#2b2b2b',
        color: '#80daff',
        backgroundImage: "url('/__assets/global/7d4d8f19-77aa-4c3a-882c-48650c2cb153')",
        backgroundPosition: '50% 50%',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover'
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          height: '100%',
          width: '800px'
        }}
      >
        <DAZZMLogo />
        {language === 'fr' ? <FrenchContent /> : <EnglishContent />}
      </div>
    </div>
  );
}

function EnglishContent() {
  return (
    <>
      <h1 style={{ textAlign: 'center' }}>Scheduled maintenance</h1>
      <h2 style={{ textAlign: 'center' }}>
        We are performing scheduled maintenance on this application. It should be back online
        shortly. Thank you for your patience.
      </h2>
    </>
  );
}

function FrenchContent() {
  return (
    <>
      <h1 style={{ textAlign: 'center' }}>Maintenance planifiée</h1>
      <h2 style={{ textAlign: 'center' }}>
        Nous effectuons une maintenance planifiée sur cette application. Le service devrait être
        rétabli sous peu. Merci de votre patience.
      </h2>
    </>
  );
}
